<app-ace-select
  #aceSelect
  [items]="countries"
  [multiSelect]="false"
  [placeholder]="placeholder"
  [hideSelected]="true"/>
